// extracted by mini-css-extract-plugin
export var quillEditor = "_mo-1";
export var variable = "_mo-0";